import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import FeedPage from "./pages/FeedPage";
import SurveyPage from "./pages/SurveyPage";
import "./styles/global.css";

export default function App() {
  return (
    <Router>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<FeedPage />} />
            <Route path="/analysis" element={<FeedPage />} />
            <Route path="/news" element={<FeedPage />} />
            <Route path="/updates" element={<FeedPage />} />
            <Route path="/surveys" element={<SurveyPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
